module.exports = __webpack_public_path__ + "img/forum-title.d798a87e.png";